import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
import { domainSsoEnforcementParser } from '#validation/domain/parsers';
export const verifiedDomainConfigResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    createdAt: dateParser(),
    updatedAt: dateParser(),
    ssoEnforcementType: domainSsoEnforcementParser,
    /**
     * This is a custom solution, so we deliberately omit the property entirely
     * for anyone who has not set it, instead of surfacing `false`.
     */
    remapParentDomainEmails: z.literal(true).optional(),
});
export class VerifiedDomainConfigResponseDto extends createZodDto(verifiedDomainConfigResponseSchema) {
}
